export default {"src":"/_next/static/media/DISA.3886e843.svg","height":18,"width":18};